import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { UseCase } from "../../base";
import { GetMasterPlanLocationLookupRequest, MasterPlanLocation } from "../../domain";
import { MasterPlansRepository } from "../../repositories";

@Injectable({ providedIn: 'root' })
export class GetMasterPlanLocationUseCase implements UseCase<GetMasterPlanLocationLookupRequest, MasterPlanLocation[]>{
    
    constructor(private readonly masterPlanRepository: MasterPlansRepository){
    }

    execute(param: GetMasterPlanLocationLookupRequest): Observable<MasterPlanLocation[]>{
        return this.masterPlanRepository.getMasterPlanLocations(param);
    }
}